<template>
	<div id="modal-create-project" class="modal-new hidden">
		<svg
			v-if="project.id"
			@click="onCancel"
			class="btn-close-modal"
			xmlns="http://www.w3.org/2000/svg"
			height="24"
			viewBox="0 0 24 24"
			width="24"
		>
			<path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
			<path d="M0 0h24v24H0z" fill="none" />
		</svg>
		<span class="title">Create New Project</span>
		<input type="text" placeholder="Name" @keyup.enter="onCreate" v-model="projectName" required />
		<p v-if="error" class="error-message">Project named '{{ errorProjectname }}' already exists.</p>
		<div class="buttons-continer">
			<button type="button" class="modal-btn --primary" :class="{ '--disabled': loadingProject }" @click="onCreate">
				<v-progress-circular v-if="loadingProject" indeterminate color="#fff" size="18" width="3"></v-progress-circular>
				<span v-else>Create</span>
			</button>
			<button type="button" class="modal-btn --cancel" :class="{ '--disabled': loadingProject }" @click="onCancel">Cancel</button>
		</div>
	</div>
</template>

<script>
import { mapState } from "vuex";
import LoadScripts from "@/mixins/LoadScripts";

export default {
	mixins: [LoadScripts],

	data() {
		return {
			projectName: null,
			loadingProject: false,
			error: false,
			errorProjectname: null,
		};
	},
	computed: {
		...mapState("User", ["account"]),
		...mapState("Projects", ["project"]),
	},
	methods: {
		async onCreate() {
			if (this.loadingProject) return;
			if (this.errorProjectname == this.projectName) return;
			this.error = false;
			this.loadingProject = true;

			let response = await this.$store.dispatch("Projects/createProject", {
				name: this.projectName,
			});

			if (response.status == 422) {
				this.error = true;
				this.errorProjectname = this.projectName;
				this.loadingProject = false;
				this.projectName = "";
				return;
			}

			await this.$store.dispatch("Projects/fetchProjects");

			// on first project load
			if (!this.project.id) {
				await this.loadScripts();
				this.$store.dispatch("App/setScriptsLoaded");
				this.$store.dispatch("App/setIDTList", window.config.IDT);
				this.$store.dispatch("App/setODTList", window.config.ODT);
			}

			if (this.$store.state.App.scriptsLoaded) {
				if (this.project.id) this.$store.dispatch("Projects/switchProject");
				await this.$store.dispatch("Projects/setProjectId", response.data.id);
				await this.$store.dispatch("Projects/selectProject");
				// await this.$store.dispatch("Projects/refreshProjectTree");
				await this.$store.dispatch("Projects/refreshProjectTree", {
					createPresignedURL: true,
				});
				this.$store.dispatch("Projects/openAllProjectTree");
                this.$store.dispatch('User/subscribeToChannels');

				document.querySelector("#modal-create-project").classList.toggle("hidden");
				document.querySelector("#modal-create-project").classList.toggle("fadeInDownModal");
				document.querySelector("#app-view").classList.toggle("overlay");
				window.lutify.activeModal = null;

				this.projectName = null;
				this.loadingProject = false;
				if (!this.$store.state.UI.UILoadedStatus) window.UI.startApp();
			}
		},
		onCancel() {
			if (this.loadingProject) return;

			document.querySelector("#modal-create-project").classList.toggle("hidden");
			document.querySelector("#modal-create-project").classList.toggle("fadeInDownModal");
			document.querySelector("#project-selector-modal").classList.toggle("hidden");
			document.querySelector("#project-selector-modal").classList.toggle("fadeInDownModal");
		},
	},
};
</script>

<style lang="scss">
#modal-create-project {
	.error-message {
		margin-top: -10px;
		margin-bottom: 20px;
	}
}
</style>
